import config from 'config';
import {getAuthToken} from 'services/auth';
import {NotAuthorizedError, NotFoundError, ValueError} from 'util/errors';

export type API_METHOD = 'GET'|'POST'|'PUT'|'DELETE';

export async function callAPI(url: string, method: API_METHOD, data: {[index:string]:any}|FormData|null = null, authenticate: boolean = false): Promise<any> {
  const headers: any = { 'Content-Type': 'application/json' };
  const request: RequestInit = {
    method: method,
    headers: headers
  };
  if(method !== 'GET') {
    if(data instanceof FormData) {
      delete headers['Content-Type'];
      request.body = data;
    } else {
      request.body = JSON.stringify(data);
    }
  }
  if(authenticate) {
    const token = getAuthToken();
    if(token) {
      headers['Authorization'] = `Token ${token}`;
    }
  }
  const response = await fetch(`${config.api.url}${url}`, request);
  switch(response.status) {
    case 200:
    case 201:
      const fullContentType = response.headers.get('Content-Type')
      const contentType = fullContentType ? fullContentType.split(';')[0] : null;
      switch(contentType) {
        case 'application/json':
          return await response.json();
        case 'application/pdf':
        case 'application/zip':
        case 'text/csv':
          return await response.blob();
        default:
          return null;
      }
    case 400:
      throw await parseResponseValueError('Request failed', response);
    case 401:
    case 403:
      throw new NotAuthorizedError();
    case 404:
      throw new NotFoundError();
    case 204:
      return null;
    default:
      throw response;
  }
}

async function parseResponseValueError(message: string, response: Response): Promise<ValueError> {
  let data;
  try {
    data = await response.json();
  } catch {
    return new ValueError(message);
  }
  let errors: string[] = [];
  const fieldErrors: {[index:string]:string[]} = {};
  if(Array.isArray(data)) {
    errors = data;
  } else {
    for(const key of Object.keys(data)) {
      if(key === 'non_field_errors') {
        errors = errors.concat(data[key]);
      } else {
        fieldErrors[key] = (fieldErrors[key] || []).concat(data[key]);
      }
    }
  }
  return new ValueError(message, fieldErrors, errors);
}